/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import Form from "react-bootstrap/Form";
import "./invest-rest.scss";
import { FUNDTYPE, RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";

import {
  addCommas,
  calculateVintage,
  COLOR_PALETTE,
  findFunds,
  openPopup,
  parseInputValue,
} from "../../helpers/helpers";
import LoadingSpinner from "../../atoms/Loader";
import { InvestTheRestContext } from "../../context/RAContextProviders/investTheRestContext";

const InvestRest = (props) => {
  const { choose, data, taxfreecash } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const { data: personalData } = useSelector(
    (state) => state.home // eslint-disable-line
  );
  const { cardData } = props;
  const { payoutRateData } = useSelector((state) => state.payoutRate);
  const { raCMSFundsFetching, raCMSFundsData } = useSelector(
    (state) => state.raCMSFunds,
  );

  const [legacySliderValue, setLegacySliderValue] = useState(0);
  const [legacyInputValue, setLegacyInputValue] = useState("0%");
  const [safetySliderValue, setSafetySliderValue] = useState(0);
  const [safetyInputValue, setSafetyInputValue] = useState("0%");
  const [flexiSliderValue, setFlexiSliderValue] = useState(0);
  const [flexiInputValue, setFlexiInputValue] = useState("0%");
  const [faRate, setFaRate] = useState(0);
  const [currentIncome, setCurrentIncome] = useState(0);
  const [frequency, setFrequency] = useState("Monthly");
  const [miRate, setMiRate] = useState(0);
  const [cmsStrategy, setCmsStrategy] = useState();
  const {
    keepYesCheckboxChecked,
    flexiValueInvestRest,
    safetyValueInvestRest,
    legacyValueInvestRest,
    resetInvestTheRestValues,
  } = useContext(InvestTheRestContext);

  const navigate = useNavigate(); // eslint-disable-line
  const dispatch = useDispatch();
  const { getRACMSFunds, getPayoutRate, getHomePageContent } =
    bindActionCreators(actionCreators, dispatch);
  useEffect(() => {
    if (Object.keys(personalData).length === 0) {
      getHomePageContent(props.investorId);
    }
    if (keepYesCheckboxChecked) {
      setCheckOption((prevCheckData) => {
        return prevCheckData.map((item, index) => {
          return {
            ...item,
            value: index === 0 ? keepYesCheckboxChecked : false,
          };
        });
      });
      setFlexiSliderValue(flexiValueInvestRest);
      setSafetySliderValue(safetyValueInvestRest);
      setLegacySliderValue(legacyValueInvestRest);

      // clear invest the rest context states
      resetInvestTheRestValues();
    }
  }, []);

  useEffect(() => {
    if (
      Object.keys(payoutRateData).length === 0 &&
      personalData?.timeTravel?.birthDate !== undefined
    ) {
      const birthYear = new Date(
        personalData.timeTravel.birthDate,
      ).getFullYear();
      const retirementYear = new Date(
        personalData.timeTravel.retirementDate,
      ).getFullYear();
      getPayoutRate(props.investorId, retirementYear - birthYear);
    }
    if (Object.keys(raCMSFundsData).length === 0) {
      getRACMSFunds(props.investorId);
    }
  }, [personalData]);

  const totalCardValue =
    legacySliderValue + safetySliderValue + flexiSliderValue;
  const totalCardValueInput =
    parseFloat(legacyInputValue) +
    parseFloat(safetyInputValue) +
    parseFloat(flexiInputValue);
  const handleSafetySliderChange = (e) => {
    const value = e.target.value;
    setSafetySliderValue(value);
    setSafetyInputValue(`${value}%`);
  };

  const handleSafetyInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setSafetySliderValue(result.numericValue);
      setSafetyInputValue(result.formattedValue);
    }
  };

  const handleLegacySliderChange = (e) => {
    const value = e.target.value;
    setLegacySliderValue(value);
    setLegacyInputValue(`${value}%`);
  };

  const handleLegacyInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setLegacySliderValue(result.numericValue);
      setLegacyInputValue(result.formattedValue);
    }
  };

  const handleFlexiInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setFlexiInputValue(result.formattedValue);
      setFlexiSliderValue(result.numericValue);
    }
  };

  const handleFlexiSliderChange = (e) => {
    const value = e.target.value;
    setFlexiSliderValue(value);
    setFlexiInputValue(`${value}%`);
  };

  const detailsData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;
  const applicationPotsSelected =
    data?.applicationPots?.length > 0
      ? data?.applicationPots
      : JSON.parse(localStorage.getItem("applicationPots"));
  const potUsedInPotSelection = detailsData?.monetaryChosenAmount;
  const taxFreeCashAmt = (
    potUsedInPotSelection *
    (taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100)
  ).toFixed(2);
  const tetaxableCash = (3 * taxFreeCashAmt).toFixed(2);

  const handleBack = () => {
    props.makeInitialStepper(
      false,
      34,
      { isTakeTaxFreeCashInvestRest: true },
      true // eslint-disable-line
    );
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST;
    let investTheRest = {
      safetyNet: safetySliderValue ? true : false,
      investRestsafetyNetPer: parseFloat(safetySliderValue),
      legacy: legacySliderValue ? true : false,
      investRestLegacyPerc: parseFloat(legacySliderValue),
      flexiAccess: checkOption[1]?.value
        ? true
        : flexiSliderValue
          ? true
          : false,
      investRestFlexiAccessPerc: checkOption[1]?.value
        ? 100
        : parseFloat(flexiSliderValue),
    };
    let payload = {
      currentStep,
      choiceCategory: { taxFreeCash: { investTheRest } },
    };
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST, payload);
  };

  const [checkOption, setCheckOption] = useState([
    {
      checkboxName: "confirmations",
      value: false,
      id: 1,
      label: (
        <>
          Yes, I'd like to choose <span className="fw-bold">safety net</span> or{" "}
          <span className="fw-bold"> legacy </span>for some or all of my
          drawdown
        </>
      ),
    },
    {
      checkboxName: "confirmations",
      value: true,
      id: 2,
      label: (
        <>
          No, please continue to move my taxable pension savings to{" "}
          <span className="fw-bold"> flexi-access </span> and I will manage my
          investments later
        </>
      ),
    },
  ]);
  const handleCheckOption = () => {
    setCheckOption((prevCheckData) => {
      return prevCheckData.map((item) => {
        return { ...item, value: !item.value };
      });
    });
  };

  const calculateTotalValue = (sliderValue) => {
    return (tetaxableCash * sliderValue) / 100;
  };

  const potUsedOfTotalIndividualPotForInvestTheRest =
    potUsedInPotSelection / detailsData?.monetaryActualAmount;

  const individualPotTaxFreePercentage =
    taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100;

  useEffect(() => {
    setCurrentIncome(payoutRateData[0]?.currentIncome);
    setFrequency(payoutRateData[0]?.duration);
    setMiRate(payoutRateData[0]?.payOutRates?.managed_income_95_payout_rate);
    setFaRate(payoutRateData[0]?.payOutRates?.future_annuity_75_payout_rate);
  }, [payoutRateData]);

  useEffect(() => {
    const vintage = calculateVintage(
      personalData?.timeTravel?.birthDate?.split("-")[0] // eslint-disable-line
    );

    var colorIndex = COLOR_PALETTE.length;
    setCmsStrategy(
      findFunds(
        raCMSFundsData?.data,
        vintage.age75Year,
        vintage.age95Year // eslint-disable-line
      )?.map(
        (item) => {
          const {
            investmentStyle,
            averageESGRating,
            fundFactsheets,
            fundUse,
            fundObjectiveTruncated,
            composerFundNameTruncated,
            investmentId,
            fundName,
            ...rest
          } = item;
          if (investmentId !== null) {
            return {
              strategyId: investmentId,
              strategyName: fundName,
              fundId: composerFundNameTruncated,
              fundType:
                investmentStyle === "Managed for you"
                  ? FUNDTYPE.MANAGED_FOR_ME
                  : investmentStyle,
              ESGRating: averageESGRating,
              managedBy: fundUse,
              shortDesc: fundObjectiveTruncated,
              pDFUrl: fundFactsheets ? fundFactsheets[0].url : null,
              strategyPercentage: 0,
              incomePercentage: 0,
              newCurrentValue: 0,
              newCurrentIncome: 0,
              currentValue: 0,
              currentIncome: 0,
              category:
                fundName.toLowerCase() === "future annuity income fund" ||
                fundName.toLowerCase() === "managed income fund"
                  ? "For Income"
                  : fundName.toLowerCase() === "legacy fund" ||
                      fundName.toLowerCase() === "safety net fund"
                    ? "For Growth"
                    : "",
              color: COLOR_PALETTE[--colorIndex],
              ...rest,
            };
          }
        } // eslint-disable-line
      ) // eslint-disable-line
    );
  }, [personalData, raCMSFundsData]);

  props.setFaiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Future Annuity Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );

  props.setMiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Managed Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setLeId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Legacy Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setSnId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Safety Net Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );

  const generateProductOverviewLink = (
    contentType,
    parentStrategyName,
    strategyName,
  ) => {
    let tptProductRoute;
    let finalPath;
    const productOverview = cardData?.items?.filter((productOverview) => {
      return (
        productOverview.contentType === contentType &&
        productOverview.name === parentStrategyName
      );
    });
    if (contentType === "productPage") {
      finalPath = productOverview[0]?.route?.path.replace(
        "/guidance/",
        "" //eslint-disable-line
      );
    } else {
      tptProductRoute =
        productOverview[0]?.properties?.optionItem?.items?.filter?.(
          (item) =>
            item?.content?.properties?.retirementOptionListTitle ===
            strategyName //eslint-disable-line
        );
      finalPath =
        tptProductRoute[0]?.content?.properties?.cTA[0]?.route?.path.replace(
          "/guidance/",
          "" //eslint-disable-line
        );
    }
    navigate(`/product-overview/?${finalPath.replace(/\/$/, "")}`, {
      state: {
        doNotCallGetApi: true,
        keepYesChecked: checkOption?.[0]?.value,
        flexiSliderValue: parseFloat(flexiSliderValue),
        safetySliderValue: parseFloat(safetySliderValue),
        legacySliderValue: parseFloat(legacySliderValue),
      },
    });
  };

  if (raCMSFundsFetching) {
    return <LoadingSpinner width={55} />;
  }

  return (
    <>
      <Card className="application-step">
        <Card.Body className="invest-rest">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance _title">Investing the rest</p>
            </Col>
          </Row>
          <Row className="invest_content">
            <Col md={6} className="invest_content-left">
              <div>
                We'll move your taxable pension savings into the
                <span className="fw-bold"> flexi-access </span>
                part of your TPT drawdown account, and your current investments
                will be carried across to this. Any Growth Plan 3 amount will
                initially be invested in the Target Date Fund associated with
                your target retirement age. If you prefer, you can choose to set
                all or some of your money aside in the{" "}
                <span className="fw-bold">safety net</span> or
                <span className="fw-bold"> legacy </span> drawdown selections.
              </div>
              <div className="mt-16">
                You can manage your drawdown funds and change investments at any
                time once we’ve moved this money to drawdown.
              </div>
              <p className="mt-28 ">Would you like to explore these options?</p>
              <div>
                {checkOption?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={index == 1 ? "checkbox-text" : ""}
                    >
                      <span>
                        <CustomCheckbox
                          name={item.checkboxName}
                          type="radio"
                          label={item.label}
                          checked={item.value}
                          variantName="custom-checkbox mt-3"
                          onChange={() => {
                            handleCheckOption(item.id);
                          }}
                        />
                      </span>
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col md={6} className="bg-text">
              {taxfreecash?.choiceCategory?.taxFreeCash?.islumpSum === true && (
                <>
                  <div className="inv_header mb-2">
                    You've chosen to take your tax-free cash and invest the rest
                  </div>
                  {applicationPotsSelected?.map((item) => (
                    <div key={item.potId} className="mb-4">
                      <div className="d-flex justify-content-between mb-1">
                        <div> Retiring with:</div>
                        <div className="tb">
                          <span>
                            {item.potId}&nbsp;&nbsp;{item.potName}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <div> Applying with:</div>
                        <div className="tb">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotForInvestTheRest
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <div> Taking as tax free cash:</div>
                        <div className="tb">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotForInvestTheRest *
                                individualPotTaxFreePercentage
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <div> Moving to drawdown:</div>
                        <div className="tb">
                          {"£" +
                            addCommas(
                              (
                                3 *
                                item.potValue *
                                potUsedOfTotalIndividualPotForInvestTheRest *
                                individualPotTaxFreePercentage
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </Col>
          </Row>

          {checkOption.find((obj) => obj.id === 1).value === true ? (
            <div className="mt-2 g-4 mt-5">
              <Row>
                <Col lg={6} xl={4}>
                  <div className="retirement-card">
                    <div className="sub-header-div">
                      <span
                        className="circle ps-2 mt-1"
                        style={{
                          backgroundColor: COLOR_PALETTE[1],
                        }}
                      ></span>
                      <span className="sub-header">Flexi-access</span>
                      <hr className="upper-line" />
                    </div>{" "}
                    <p className="fund-text-flexi">
                      A fully flexible option where you decide the funds you’d
                      like to invest, when you take out money and how much.
                    </p>
                    <Row className="fund-text-estimated">
                      <Col lg={6} md={6}>
                        Estimated value:
                      </Col>
                      <Col lg={6} md={6} className="fund-value">
                        {"£" +
                          addCommas(
                            calculateTotalValue(flexiSliderValue).toFixed(2) //eslint-disable-line
                          )}{" "}
                      </Col>
                    </Row>
                    <Row className="parent-text">
                      <Col lg={6} md={6} className="fund-text-current">
                        Current income:
                      </Col>
                      <Col lg={6} md={6} className="fund-value-current-flexi">
                        {"£" +
                          addCommas(
                            currentIncome //eslint-disable-line
                          )}{" "}
                        {frequency === "Monthly"
                          ? "p/m"
                          : frequency === "Quarterly"
                            ? "p/q"
                            : frequency === "HalfYearly"
                              ? "p/6m"
                              : frequency === "Annual"
                                ? "p/y"
                                : ""}
                      </Col>
                    </Row>
                    <hr className="lower-line" />
                    <Row className="fund-text slider-card-section">
                      <Col lg={7} md={7} className="card-slide">
                        <Form.Range
                          value={flexiSliderValue}
                          name="flexiSlider"
                          max={100}
                          onChange={handleFlexiSliderChange}
                          className="change-investment-slider"
                        />
                      </Col>
                      <Col lg={4} md={4} className="card-input">
                        <input
                          type="text"
                          className="input-text"
                          value={`${flexiSliderValue}%`}
                          onChange={handleFlexiInputChange}
                          min="0"
                          max="100"
                        />
                      </Col>
                    </Row>
                    <Row className="fund-text prod-guide">
                      <Col>
                        <div className="button-align">
                          <Buttons
                            name="See product guide"
                            className="secondary"
                            handleClick={() => {
                              generateProductOverviewLink(
                                "questionPage",
                                "Take regular income",
                                "Self-managed regular income" //eslint-disable-line
                              );
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={6} xl={4}>
                  <div className="retirement-card">
                    <div className="sub-header-div">
                      <span
                        className="circle ps-2 mt-1"
                        style={{
                          backgroundColor: COLOR_PALETTE[9],
                        }}
                      ></span>
                      <span className="sub-header">Safety net</span>
                      <hr className="upper-line" />
                    </div>{" "}
                    <p className="fund-text">
                      {
                        cmsStrategy?.find(
                          (fund) => fund?.strategyName === "Safety Net Fund" //eslint-disable-line
                        )?.shortDesc
                      }
                    </p>
                    <Row className="fund-text-estimated">
                      <Col lg={6} md={6}>
                        Estimated value:
                      </Col>
                      <Col lg={6} md={6} className="fund-value">
                        {"£" +
                          addCommas(
                            calculateTotalValue(safetySliderValue).toFixed(2) //eslint-disable-line
                          )}{" "}
                      </Col>
                    </Row>
                    <hr className="lower-line" />
                    <Row className="fund-text slider-card-section">
                      <Col lg={7} md={7} className="card-slide">
                        <Form.Range
                          value={safetySliderValue}
                          name="safetySlider"
                          max={100}
                          onChange={handleSafetySliderChange}
                          className="custom-slider"
                        />
                      </Col>
                      <Col lg={4} md={4} className="card-input">
                        <input
                          type="text"
                          className="input-text"
                          value={`${safetySliderValue}%`}
                          onChange={handleSafetyInputChange}
                          min="0"
                          max="100"
                        />
                      </Col>
                    </Row>
                    <Row className="fund-text prod-guide">
                      <Col lg={6} md={6}>
                        <div className="button-align-safety">
                          <div className="view-fund-button">
                            <Buttons
                              name="View full fund fact sheet"
                              className="tertiary"
                              handleClick={() =>
                                openPopup(
                                  cmsStrategy?.find(
                                    (fund) =>
                                      fund?.strategyName === "Safety Net Fund" //eslint-disable-line
                                  )?.pDFUrl //eslint-disable-line
                                )
                              }
                            ></Buttons>
                          </div>
                          <Buttons
                            name="See product guide"
                            className="secondary"
                            handleClick={() => {
                              generateProductOverviewLink(
                                "productPage",
                                "Tax-free cash as a lump sum, safety net",
                                "Safety net for investing your drawdown" //eslint-disable-line
                              );
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={6} xl={4}>
                  <div className="retirement-card">
                    <div className="sub-header-div">
                      <span
                        className="circle ps-2 mt-1"
                        style={{
                          backgroundColor: COLOR_PALETTE[3],
                        }}
                      ></span>
                      <span className="sub-header">Legacy</span>
                      <hr className="upper-line" />
                    </div>{" "}
                    <p className="fund-text-legacy">
                      {
                        cmsStrategy?.find(
                          (fund) => fund?.strategyName === "Legacy Fund" //eslint-disable-line
                        )?.shortDesc
                      }
                    </p>
                    <Row className="fund-text-estimated">
                      <Col lg={6} md={6}>
                        Estimated value:
                      </Col>
                      <Col lg={6} md={6} className="fund-value">
                        {"£" +
                          addCommas(
                            calculateTotalValue(legacySliderValue).toFixed(2) //eslint-disable-line
                          )}{" "}
                      </Col>
                    </Row>
                    <hr className="lower-line" />
                    <Row className="fund-text slider-card-section">
                      <Col lg={7} md={7} className="card-slide">
                        <Form.Range
                          value={legacySliderValue}
                          name="legacySlider"
                          max={100}
                          onChange={handleLegacySliderChange}
                          className="custom-slider"
                        />
                      </Col>
                      <Col lg={4} md={4} className="card-input">
                        <input
                          type="text"
                          className="input-text"
                          value={`${legacySliderValue}%`}
                          onChange={handleLegacyInputChange}
                          min="0"
                          max="100"
                        />
                      </Col>
                    </Row>
                    <Row className="fund-text prod-guide">
                      <Col lg={6} md={6}>
                        <div className="button-align-legacy">
                          <div className="view-fund-button">
                            <Buttons
                              name="View full fund fact sheet"
                              className="tertiary"
                              handleClick={() =>
                                openPopup(
                                  cmsStrategy?.find(
                                    (fund) =>
                                      fund?.strategyName === "Legacy Fund" //eslint-disable-line
                                  )?.pDFUrl //eslint-disable-line
                                )
                              }
                            ></Buttons>
                          </div>
                          <Buttons
                            name="See product guide"
                            className="secondary"
                            handleClick={() => {
                              generateProductOverviewLink(
                                "productPage",
                                "Tax-free cash as a lump sum, legacy",
                                "Legacy for investing your drawdown" //eslint-disable-line
                              );
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            ""
          )}
          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />
            <div>
              <span className="funds-selected">
                Allocated: {Number(totalCardValueInput)}%
              </span>
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
                disabled={
                  checkOption.find((obj) => obj.id === 2).value === true ||
                  Number(totalCardValue) === 100 ||
                  Number(totalCardValueInput) === 100
                    ? false
                    : true
                }
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export default InvestRest;
